import { render, staticRenderFns } from "./font-family-selector.vue?vue&type=template&id=5888ec46&"
import script from "./font-family-selector.vue?vue&type=script&lang=js&"
export * from "./font-family-selector.vue?vue&type=script&lang=js&"
import style0 from "./font-family-selector.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports